/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetEstimatedPriceRequestDto
 */
export interface SetEstimatedPriceRequestDto {
    /**
     * 
     * @type {number}
     * @memberof SetEstimatedPriceRequestDto
     */
    min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SetEstimatedPriceRequestDto
     */
    max?: number | null;
}

/**
 * Check if a given object implements the SetEstimatedPriceRequestDto interface.
 */
export function instanceOfSetEstimatedPriceRequestDto(value: object): value is SetEstimatedPriceRequestDto {
    return true;
}

export function SetEstimatedPriceRequestDtoFromJSON(json: any): SetEstimatedPriceRequestDto {
    return SetEstimatedPriceRequestDtoFromJSONTyped(json, false);
}

export function SetEstimatedPriceRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetEstimatedPriceRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function SetEstimatedPriceRequestDtoToJSON(json: any): SetEstimatedPriceRequestDto {
    return SetEstimatedPriceRequestDtoToJSONTyped(json, false);
}

export function SetEstimatedPriceRequestDtoToJSONTyped(value?: SetEstimatedPriceRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

